import React from "react";
import Modal from '../components/Modal'
// import LoaderButton from "../components/LoaderButton";
import { checkTranslation, translate } from "../utils/useful";
// import FormViewer from "../FormViewer";
// import SwitchInput from "../inputs/SwitchInput";
// import TopicView from "../views/messenger/sideBar/TopicView";
import StagesManager from "../components/StagesManager";
import ImportModalFirst from "./ImportModalFirst";
// import ImportModalSecond from "./ImportModalSecond";
// import ImportModalThird from "./ImportModalThird";
import ImportModalForth from "./ImportModalForth";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';


class ImportModal extends React.Component {
    state = {
        Storages: [
            { icon: "/assets/icons/uploadmodal/paperclip.svg", title: "{{lang}}My Device" },
            { icon: "/assets/icons/uploadmodal/paperclip.svg", title: "{{lang}}Yonnect Drive" },
            { icon: "/assets/icons/uploadmodal/link.svg", title: "{{lang}}Link (URL)" },
            { icon: "/assets/icons/uploadmodal/googledrive.svg", title: "{{lang}}Google Drive" },
            { icon: "/assets/icons/uploadmodal/onedrive.svg", title: "{{lang}}One Drive" },
            { icon: "/assets/icons/uploadmodal/dropbox.svg", title: "{{lang}}DropBox" },
        ],

        options: [

        ],
        importInfo: {
            settings: {

            },
            fields: {

            }
        }
    }

    // setRawHeaders = (rawHeaders, cb) => {
    //     this.setState({ rawHeaders }, () => {
    //         cb()
    //     })
    // }

    changeImportInfo = (key, value, cb) => {

        let importInfo = this.state.importInfo
        importInfo[key] = value
        this.setState({ importInfo }, () => {
            console.log('thisss.ssssssss,', this.state.importInfo);
            if (cb) { cb() }
        })
    }
    hideModal = () => {

      this.modal.hideModal()
    }


    render() {
        let options = this.state.options
        return (

            <Modal height={"100%"} ref={el => this.modal = el} maxWidth={500}>
                <div className="w-100 br-10 flexc" style={{ backgroundColor: "#f6f6f6", overflow: "auto", height: "380px", borderRadius: '10px' }} >
                    {/* <div className="d-flex h-100 flex-column importmodal-hover p-3">
                        {this.state.Storages.map((prop, index) => {
                            return (
                                <div className="" key={index}>
                                    <button className="flexc btn-hover w-100 br-10 p-2 my-1" style={{ overflow: "hidden" }}>
                                        <img width={22} src={prop.icon} />
                                        <p className="mld-3" style={{ whiteSpace: "nowrap" }}>{checkTranslation(prop.title)}</p>
                                    </button>
                                </div>
                            )
                        })}
                    </div> */}
                    <StagesManager height={"100%"} width={"100%"} ref={el => this.stageManager = el} fast={true}>
                        <ImportModalFirst changeStage={this.changePage} hideModal={this.hideModal} stage={0} stageName={'fist'} applet={this.props.applet} headers={this.props.headers} page={this.props.page} changeImportInfo={this.changeImportInfo} importInfo={this.state.importInfo} />
                        {/* <ImportModalSecond width={this.props.width} changeStage={this.changePage} stage={1} stageName={'second'} />
                        <ImportModalThird width={this.props.width} changeStage={this.changePage} stage={1} stageName={'third'} /> */}
                        <ImportModalForth changeStage={this.changePage} stage={1} stageName={'mapData'} headers={this.props.headers} page={this.props.page} importInfo={this.state.importInfo} changeImportInfo={this.changeImportInfo} colors={this.props.colors} actions={this.props.actions} queque={this.state.queque} />
                    </StagesManager>
                </div>
            </Modal>
        );

    }
}


// export default ImportModal;

const mapStateToProps = state => ({ queque: state.queque })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ImportModal);